import React, { useState, useEffect } from 'react';
import './BetaLaunchPopup.css';

// Konfigurierbare Inhalte für einfache Änderungen
const popupContent = {
  title: "🎮 Welcome to VersusArena BETA",
  subtitle: "The Future of Competitive Gaming is Here!",
  sections: {
    currentFeatures: {
      title: "🚀 Live Now - Start Your Journey:",
      items: [
        "Build your gaming network with friends worldwide",
        "Real-time chat with fellow competitors", 
        "Join exclusive gaming communities",
        "Secure your whitelist spot for VersusToken airdrops",
        "Challenge opponents through our Telegram bot",
        "Rate games and share your expertise",
        "Complete profile setup in under 2 minutes"
      ]
    },
    upcomingFeatures: {
      title: "⚡ Coming in Updates - The Revolution Continues:",
      items: [
        "Direct opponent matching on our platform",
        "Advanced community features: groups, forums & tournaments",
        "VersusToken ecosystem launch with earning potential",
        "Exclusive tournament announcements & partnerships",
        "Integrated live streaming via Twitch & Pupfun",
        "Smart matchmaking for competitive & cooperative play",
        "Global esports accessibility for every skill level"
      ]
    }
  },
  footer: "Join thousands of gamers already dominating the arena! 🏆"
};

const BetaLaunchPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  useEffect(() => {
    // Check if user has already seen the popup
    const popupSeen = localStorage.getItem('betaLaunchPopupSeen');
    
    if (popupSeen) {
      const { timestamp } = JSON.parse(popupSeen);
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      
      // If it's been more than 7 days, show popup again
      if (new Date(timestamp) < sevenDaysAgo) {
        localStorage.removeItem('betaLaunchPopupSeen');
        showPopup();
      }
    } else {
      // First time visit - show popup after delay
      showPopup();
    }

    function showPopup() {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500); // Show after 1.5 seconds
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    // Store the popup seen flag with current timestamp
    const popupData = {
      seen: true,
      timestamp: new Date().toISOString(),
      version: '1.0'
    };
    localStorage.setItem('betaLaunchPopupSeen', JSON.stringify(popupData));

    // Animate out before hiding
    setIsAnimatingOut(true);
    setTimeout(() => {
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`beta-popup-overlay ${isAnimatingOut ? 'beta-popup-overlay--hiding' : ''}`}
      onClick={handleClose}
    >
      <div 
        className={`beta-popup-container ${isAnimatingOut ? 'beta-popup-container--hiding' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header with close button */}
        <div className="beta-popup-header">
          <h1 className="beta-popup-title">{popupContent.title}</h1>
          <p className="beta-popup-subtitle">{popupContent.subtitle}</p>
          <button 
            className="beta-popup-close-btn"
            onClick={handleClose}
            aria-label="Close popup"
          >
            ✕
          </button>
        </div>

        {/* Content sections */}
        <div className="beta-popup-content">
          {/* Current features */}
          <div className="beta-popup-section">
            <h2 className="beta-popup-section-title current">
              <span className="beta-popup-icon">✅</span>
              {popupContent.sections.currentFeatures.title}
            </h2>
            <ul className="beta-popup-list">
              {popupContent.sections.currentFeatures.items.map((item, index) => (
                <li key={index} className="beta-popup-list-item">
                  <span className="beta-popup-bullet">🎯</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Upcoming features */}
          <div className="beta-popup-section">
            <h2 className="beta-popup-section-title upcoming">
              <span className="beta-popup-icon">🚀</span>
              {popupContent.sections.upcomingFeatures.title}
            </h2>
            <ul className="beta-popup-list">
              {popupContent.sections.upcomingFeatures.items.map((item, index) => (
                <li key={index} className="beta-popup-list-item">
                  <span className="beta-popup-bullet">⚡</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div className="beta-popup-footer">
          <p className="beta-popup-footer-text">{popupContent.footer}</p>
          <button 
            className="beta-popup-cta-button"
            onClick={handleClose}
          >
            LET'S GO!
          </button>
        </div>
      </div>
    </div>
  );
};

export default BetaLaunchPopup;
